import { isEmpty, isEqual, pick } from 'lodash';
import * as MUTATIONS from './mutations';
import * as ACTION from './actions';
import * as userApi from '../../../api/user';
import { USER_UPDATE } from './mutations';

/**
 * Default state for user
 * @returns {{firstname: null, id: null, email: null, lastname: null}}
 */
function initialState() {
  return {
    id: null,
    email: null,
    firstname: null,
    lastname: null,
    contractor: null,
    partnerId: null,
    plan: null,
    privileges: [],
    isContractorUser: false,
    isContractorTeamUser: false,
    contractorTeamData: {},
  };
}

export default {
  namespaced: true,
  state: () => initialState(),

  getters: {

    /**
     * Check has user privilege
     * @param state
     * @returns {function({resource: *, code: *}): *}
     */
    hasPrivilege: (state) => ({ resource, code }) => (
      !isEmpty(state.privileges.filter((privilege) => (
        isEqual({ resource, code }, privilege))))
    ),
  },

  mutations: {
    /**
     * Set user state from payload
     * @param state
     * @param payload
     * @deprecated
     */
    [MUTATIONS.LOAD]: (state, payload) => {
      Object.keys(payload).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(state, key)) state[key] = payload[key];
      });
    },

    [MUTATIONS.SET_USER](state, payload) {
      Object.keys(payload).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(state, key)) state[key] = payload[key];
      });
    },

    /**
     * Update user state form payload
     * @param state
     * @param payload
     */
    [MUTATIONS.UPDATE]: (state, payload) => {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },

    /**
     * Clear user state
     * @param state
     */
    [MUTATIONS.CLEAR]: (state) => {
      const init = initialState();
      Object.keys(init).forEach((key) => {
        state[key] = init[key];
      });
    },

  },

  actions: {
    /**
     * Get user from server by id
     * @param context
     * @param id
     * @returns {Promise<void>}
     */
    async [ACTION.USER](context, id) {
      const response = await userApi.user({ id });
      if (response.data) context.commit(MUTATIONS.LOAD, response.data);
      else context.commit(MUTATIONS.CLEAR);
    },

    /**
     * Request update user on server
     * @param context
     * @param payload
     * @returns {Promise<void>}
     */
    async [ACTION.UPDATE](context, payload) {
      const response = await userApi.update(payload);
      context.commit(MUTATIONS.UPDATE, pick(response.data, Object.keys(payload)));
    },

    /**
     * Request update email on server
     * @param context
     * @param payload
     * @returns {Promise<any>}
     */
    async [ACTION.UPDATE_EMAIL](context, payload) {
      const response = await userApi.updateEmail(payload);
      return response.data;
    },

    /**
     * New email confirmation
     * @param context
     * @param payload
     * @returns {Promise<boolean>}
     */
    async [ACTION.CONFIRM_CHANGE_EMAIL](context, payload) {
      const response = await userApi.confirmChangeEmail(payload);
      context.commit(USER_UPDATE, response.data);
      return true;
    },

    /**
     * Request update password on server
     * @param context
     * @param payload
     * @returns {Promise<any>}
     */
    async [ACTION.UPDATE_PASSWORD](context, payload) {
      const response = await userApi.updatePassword(payload);
      return response.data;
    },

    /**
     * Clear user state
     * @param context
     * @returns {Promise<void>}
     */
    async [ACTION.CLEAR](context) {
      context.commit(MUTATIONS.CLEAR);
    },

  },
};
